import React from 'react'
import './Experience.css'
import {BsFillPatchCheckFill} from 'react-icons/bs'

const Experience = () => {
  return (
    <section id='exprience'>
      <h5>What Skills I Have</h5>
      <h2>My Experience</h2>

      <div className='container experience__conatainer'>
        <div className='experience__frontend'>
          <h3>Frontend Development</h3>
          <div className='experience__content'>
          
          <article className='experience__details'>
          <BsFillPatchCheckFill />
          <div>
          <h4>HTML</h4>
          <small className='text-light'>Experienced</small>
          </div>
          </article>
          
          <article className='experience__details'>
          <BsFillPatchCheckFill />
          <div>
          <h4>CSS</h4>
          <small className='text-light'>Experienced</small>
          </div>
          </article>
          
          <article className='experience__details'>
          <BsFillPatchCheckFill />
          <div>
          <h4>JavaScript</h4>
          <small className='text-light'>Experienced</small>
          </div>
          </article>
          
          <article className='experience__details'>
          <BsFillPatchCheckFill />
          <div>
          <h4>Bootstrap</h4>
          <small className='text-light'>Intermediate</small>
          </div>
          </article>

          <article className='experience__details'>
          <BsFillPatchCheckFill />
          <div>
          <h4>React</h4>
          <small className='text-light'>Intermediate</small>
          </div>
          </article>

          <article className='experience__details'>
          <BsFillPatchCheckFill />
          <div>
          <h4>Tailwind</h4>
          <small className='text-light'>Learning</small>
          </div>
          </article>

          
        </div>
        </div>
        
        <div className='experience__backend'>
        <h3>Backend Development</h3>
          <div className='experience__content'>
          
          <article className='experience__details'>
          <BsFillPatchCheckFill />
          <div>
          <h4>Node JS</h4>
          <small className='text-light'>Experienced</small>
          </div>
          </article>
          
          <article className='experience__details'>
          <BsFillPatchCheckFill />
          <div>
          <h4>PHP</h4>
          <small className='text-light'>Experienced</small>
          </div>
          </article>
          
          <article className='experience__details'>
          <BsFillPatchCheckFill />
          <div>
          <h4>SQL</h4>
          <small className='text-light'>Intermeditate</small>
          </div>
          </article>
          
          <article className='experience__details'>
          <BsFillPatchCheckFill />
          <div>
          <h4>Mongo DB</h4>
          <small className='text-light'>Intermediate</small>
          </div>
          </article>

          <article className='experience__details'>
          <BsFillPatchCheckFill />
          <div>
          <h4>Java</h4>
          <small className='text-light'>Intermediate</small>
          </div>
          </article>

          <article className='experience__details'>
          <BsFillPatchCheckFill />
          <div>
          <h4>Pyhton</h4>
          <small className='text-light'>Experinced</small>
          </div>
          </article>

          
        </div>
        </div>
      </div>

    
    </section>
  )
}

export default Experience